import { render, staticRenderFns } from "./WelcomeNotification.vue?vue&type=template&id=1899568f&"
import script from "./WelcomeNotification.vue?vue&type=script&lang=js&"
export * from "./WelcomeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1899568f')) {
      api.createRecord('1899568f', component.options)
    } else {
      api.reload('1899568f', component.options)
    }
    module.hot.accept("./WelcomeNotification.vue?vue&type=template&id=1899568f&", function () {
      api.rerender('1899568f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/WelcomeNotification.vue"
export default component.exports